import { FC, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';

const NotConfirmedPage: FC = () => {
    const { token } = useParams<{ token: string }>();
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

    const handleResendEmail = async () => {
        if (!token) {
            setMessage({ type: 'error', text: 'Token non valido.' });
            return;
        }
        setIsLoading(true);
        setMessage(null);
        try {
            const response = await api.get(`/api/users/resendConfirmEmail/${token}`);
            if (response.data.status) {
                setMessage({ type: 'success', text: 'Email di conferma inviata con successo!' });
            } else {
                throw new Error(response.data.message || "Impossibile inviare l'email.");
            }
        } catch (err: any) {
            const errorMsg = err.response?.data?.message || err.message || "Si è verificato un errore.";
            setMessage({ type: 'error', text: errorMsg });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-900 flex flex-col justify-center items-center p-4">
            <div className="w-full max-w-md text-center">
                <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-8">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-amber-400 mx-auto mb-6"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
                    <h1 className="text-2xl font-bold text-white mb-4">Conferma il tuo Account</h1>
                    <p className="text-slate-400 mb-6">
                        Abbiamo inviato un'email all'indirizzo che hai fornito. Clicca sul link al suo interno per attivare il tuo account.
                    </p>

                    {message && (
                        <div className={`p-3 mb-4 rounded-lg text-sm ${message.type === 'success' ? 'bg-green-500/20 text-green-300' : 'bg-red-500/20 text-red-300'}`}>
                            {message.text}
                        </div>
                    )}

                    <button
                        onClick={handleResendEmail}
                        disabled={isLoading}
                        className="w-full px-5 py-3 rounded-lg text-white font-semibold bg-sky-600 hover:bg-sky-500 transition-colors disabled:bg-slate-600"
                    >
                        {isLoading ? 'Invio in corso...' : 'Non hai ricevuto l\'email? Invia di nuovo'}
                    </button>
                    <Link to="/login" className="mt-6 inline-block text-sm text-sky-400 hover:text-sky-300">Torna al Login</Link>
                </div>
            </div>
        </div>
    );
};

export default NotConfirmedPage;
